import { render, staticRenderFns } from "./OpenMarket.vue?vue&type=template&id=03da4f3a&scoped=true"
import script from "./OpenMarket.vue?vue&type=script&lang=js"
export * from "./OpenMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da4f3a",
  null
  
)

export default component.exports